import { Charts } from './Charts';
import AttentionChartsDataProvider from './contexts/AttentionChartsDataContext';

const AttentionWrapper = () => {
    return (
        <AttentionChartsDataProvider>
            <Charts />
        </AttentionChartsDataProvider>
    );
};

export default AttentionWrapper;
